<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg">
        <img src="assets/svg/opportunities-icon.svg" alt="">
      </div>
      <div>
        <h4 class="text-semibold">Nueva oportunidad: {{ request.tipo_empresa | titlecase }}</h4>
        <h6 class="color-gray">Completa los datos para registrar una nueva oportunidad.</h6>
      </div>
      <div>
        <img (click)="closeMdl()"  class="close-button" src="assets/svg/close-icon.svg" alt="">
      </div>
    </div>

    <div class="mdl-body">
      <h5 class="text-semibold mt-4">Información de la oportunidad</h5>
      <form #OportunityForm="ngForm" (ngSubmit)="$event.preventDefault()">
      <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
        <div>
          <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!request.nombre ||request.nombre.trim() === ''">*</span> 
              Nombre de la oportunidad:
              </label>
            <input 
            class="crm-input" 
            type="text"
            name="nombre" 
            id="nombre"
            [(ngModel)]="request.nombre"
            required
            #nameCtrl="ngModel">
            <div class="error-text" *ngIf="nameCtrl.invalid && nameCtrl.touched">
              <small *ngIf="nameCtrl.errors?.['required']">
                El nombre de la oportunidad es obligatorio
              </small>
            </div>
          </div>
          <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!request.tipo_negocio || request.tipo_negocio.trim()===''">*</span>
               Tipo de negocio:
            </label>
            <select class="crm-input"
            name="tipo_negocio"
             [(ngModel)]="request.tipo_negocio"
             required
             #tipoNegocioCtrl="ngModel">
              <option value="" disabled>Selecciona el tipo de negocio</option>
              <option value="Compra Agil">Compra Agil</option>
              <option value="Compra Directa">Compra Directa</option>
              <option value="Convenio Marco">Convenio Marco</option>
              <option value="Cotizacion">Cotización</option>
              <option value="Gran Compra">Gran Compra</option>
              <option value="Licitacion Publica">Licitación Publica</option>
            </select>
            <div class="error-text" *ngIf="tipoNegocioCtrl.invalid && tipoNegocioCtrl.touched">
              <small *ngIf="tipoNegocioCtrl.errors?.['required']">
                El tipo de negocio es obligatorio
              </small>
            </div> 
          </div>
          <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!request.id_estado || request.id_estado.trim()===''"></span>
              Etapa:
            </label>
            <select 
            class="crm-input" 
            name="estado"
             id=""
              [(ngModel)]="request.id_estado"
              >
              @for (estado of estados; track estado.id_estado) {
                  <option [value]="estado.id_estado">{{ estado.nombre }}</option>
              }
            </select>
          </div>
          <div class="mt-3">
            <label class="login-label">Importe:</label>
            <input class="crm-input" type="importe_actual" name="number" [(ngModel)]="request.importe_actual">
          </div>
          <div class="mt-3">
            <label class="login-label" for="propietario"><p class="color-org d-inline"></p>Propietario del contacto:</label>
            <div class="d-flex flex-row align-items-center color-org gap-10">
              <img src="assets/svg/avatar.svg" alt="">
              <b><u>{{ propietarioOportunidad || 'Sin propietario' }}</u></b>
            </div>
          </div>
        </div>

        <div>
          <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!selectedAccount || selectedAccount.trim()===''">*</span>
               Nombre de la cuenta:
              </label>
            <div class=" d-grid crm-ng-select input-bordered">
              <div><img style="width: 30px;" src="assets/svg/account.svg" alt="icono asignado"></div>
              <div>
                <ng-select
                  *ngIf="accounts"
                  [items]="accounts"
                  bindLabel="nombre_empresa"
                  bindValue="cuenta_id"
                  name="cuenta"
                  required
                  placeholder="Buscar cuentas..."
                  [(ngModel)]="selectedAccount"
                  (ngModelChange)="actualizarPropietario($event)"
                  [searchable]="true"
                  [clearable]="false">
                </ng-select>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <label class="login-label">
              Contacto:
            </label>
            <div class="d-grid crm-ng-select input-bordered">
              <div><img style="width: 30px;" src="assets/svg/contact-icon.svg" alt="icono contacto"></div>
              <div>
                <ng-select
                  *ngIf="contactos"
                  [items]="contactos"
                  bindLabel="nombre"
                  bindValue="contacto_id"
                  name="contacto"
                  placeholder="Buscar contacto..."
                  [(ngModel)]="request.contacto_id"
                  (ngModelChange)="actualizarPropietarioContacto($event)"
                  [searchable]="true"
                  [clearable]="true">
                </ng-select>
              </div>
            </div>
          </div>          
          <div class="mt-3">
            <label 
            class="login-label" for="fecha_cierre">
            <span class="required-asterisk" *ngIf="!request.fecha_cierre_estimada || request.fecha_cierre_estimada.trim()===''">*</span>
            Fecha de cierre:</label>
            <input 
            class="crm-input" 
            type="date" 
            name="fecha_cierre"
            required
            #fechaCierreCtrl="ngModel"
             id="fecha_cierre"
            [(ngModel)]="request.fecha_cierre_estimada" 
            [min]="today">
            <div class="error-text" *ngIf="fechaCierreCtrl.invalid && fechaCierreCtrl.touched">
              <small *ngIf="fechaCierreCtrl.errors?.['required']">
                La fecha de cierre es obligatoria
              </small>
            </div>
          </div>
          <div class="mt-3">
            <label class="login-label">Probabilidad (%):</label>
            <input class="crm-input" name="probabilidad" type="number" min="0" max="100" step="0.01" [(ngModel)]="request.probabilidad_cierre" (ngModelChange)="request.probabilidad_cierre = $event ==='' || $event ===null ? 0 : $event">
          </div>
          <div class="mt-3">
            <label class="login-label">Siguiente paso:</label>
            <input class="crm-input" name="sgte_paso" type="text" [(ngModel)]="request.sgte_paso">
          </div>
        </div>
      </div>

      <h5 class="text-semibold mt-4">Información adicional</h5>
      <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
        <div>
          <div class="mt-3">
            <label class="login-label">Categoría de previsión:</label>
            <select class="crm-input" name="categoria_prevision" [(ngModel)]="request.categoria_prevision">
              <option value="Omitida">Omitida</option>
              <option value="Oportunidades en curso">Oportunidades en curso</option>
              <option value="Maximo previsto">Maximo previsto</option>
              <option value="Confirmar">Confirmar</option>
              <option value="Cerrado">Cerrado</option>
            </select>
          </div>
          <div class="mt-3">
            <label class="login-label">Motivo de la pérdida:</label>
            <select class="crm-input" name="motivo_perdida"[(ngModel)]="request.motivo_perdida" >
              <option value="Competencia">Competencia</option>
              <option value="Sin presupuesto">Sin presupuesto</option>
              <option value="No respondio mas">No respondio mas</option>
              <option value="Precio">Precio</option>
              <option value="Otro">Otro</option>
              <option value="Fuera de plazo">Fuera de plazo</option>
            </select>
          </div>
        </div>
        <div>
          <div class="mt-3">
            <label class="login-label">Tipo:</label>
            <select class="crm-input" name="tipo_oportunidad" [(ngModel)]="request.tipo_oportunidad">
              <option value="Negocio existente">Negocio existente</option>
              <option value="Nuevo negocio">Nuevo negocio</option>
            </select>
          </div>
          <div class="mt-3">
            <label class="login-label">Descripción:</label>
            <input class="crm-input" name="descripcion" [(ngModel)]="request.descripcion">
          </div>
        </div>
      </div>
<!-- 
      <h5 class="text-semibold mt-4">Otra información</h5>
      <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
        <div class="mt-3">
          <label class="login-label">Contrato:</label>
          <input class="crm-input" type="text" [(ngModel)]="request.contrato">
        </div>
        <div class="mt-3">
          <label class="login-label">Presupuesto sincronizado:</label>
          <input class="crm-input" type="text" [(ngModel)]="request.presupuesto_sincronizado">
        </div>
      </div> -->

      <hr class="mt-5 mb-5">

      <div class="d-flex flex-row justify-center gap-20 mt-2">
        <button type="button" (click)="closeMdl()" class="btn btn-primary-outline">Cancelar</button>
        @if(data.mode === 'edit'){
            <button type="button" class="btn btn-primary text-center" (click)="updateOpportunity();" [disabled]="!OportunityForm.valid">Modificar oportunidad</button>
        }@else{
            <button type="button" class="btn btn-primary text-center" (click)="createOpportunity();" [disabled]="!OportunityForm.valid">Guardar nueva oportunidad</button>
        }
      </div>
      </form>
    </div>
  </div>
</div>